import { server, BRANCH_FAILED, BRANCH_FETCHING, BRANCH_SUCCESS } from '../../constants'
import apiEndpoint from '../../api/etrBackend'

const setStateBranchToSuccess = (payload: any) => ({
  type: BRANCH_SUCCESS,
  payload: payload
})

const setStateBranchToFetching = () => ({
  type: BRANCH_FETCHING
})

const setStateBranchToFailed = () => ({
  type: BRANCH_FAILED
})

export const getBranch = () => {
  return async (dispatch: any) => {
    try {
      dispatch(setStateBranchToFetching())

      const result = await apiEndpoint.get(`${server.INFO}/${server.BRANCH}`)
      dispatch(setStateBranchToSuccess(result.data))
    } catch (error) {
      dispatch(setStateBranchToFailed)
    }
  }
}
